// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f793e3fb","239":"aeee63b3","455":"c3ee3613"}[chunkId] + ".chunk.js";
};